<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="付款">
                <mt-button icon="back" slot="left" @click="goBack"></mt-button>
            </mt-header>
        </div>
        <div v-if="pay_info">
            <div class="top-wrapper">
                <div class="row-wrapper title-wrapper">
                    <i class="icon iconfont">&#xe6d2;</i>
                    <label class="title">订单提交成功，请选择付款方式</label>
                </div>
                <div class="row-wrapper subtitle-wrapper">
                    <label class="subtitle">合计：</label>
                    <label class="price">￥ {{pay_info.pay_amount}}</label>
                </div>
            </div>

            <mt-cell title="预存款" v-if="pay_info.member_available_pd>0">￥{{pay_info.member_available_pd}}<mt-switch v-model="payment_info.pd_pay"></mt-switch></mt-cell>
            <mt-cell title="充值卡" v-if="pay_info.member_available_rcb>0">￥{{pay_info.member_available_rcb}}<mt-switch v-model="payment_info.rcb_pay"></mt-switch></mt-cell>
            <div class="item-wrapper" v-on:click="payType(item.payment_code)" v-for="(item,index) in payment_list" :key="index">
                <div class="item-left-wrapper">
                    <i :class="setClass(item.payment_code)" ></i>
                    <label class="item-title">{{item.payment_name}}</label>
                </div>
                <div class="item-right-wrapper">
                    <i class="item-select iconfont" v-if="payment_info.payment_code == item.payment_code">&#xe69d;</i>
                </div>
            </div>
        </div>
        <mt-button class="ds-button-large" type="primary" v-on:click="submit">立即付款</mt-button>
    </div>
</template>

<script>
import { getOrderpayInfo } from '../../../api/memberBuy'
import { getVrOrderpayInfo } from '../../../api/memberVrBuy'
import { mapState } from 'vuex'
import { pay, getPaymentList } from '../../../api/memberPayment'
import { getRechargeInfo } from '../../../api/memberRecharge'
import { Toast, MessageBox } from 'mint-ui'
import { loadScript } from '../../../util/common'
export default {
  name: 'pay',
  data () {
    return {
      uniapp: 0,
      pay_sn: this.$route.query.pay_sn ? this.$route.query.pay_sn : '',
      pay_type: this.$route.query.pay_type ? this.$route.query.pay_type : '',
      // 订单支付显示的数据
      pay_info: null,
      // 提交支付需要用到的数据
      payment_info: {
        password: '', // 支付密码
        rcb_pay: 0, // 是否使用充值卡进行支付
        pd_pay: 0, // 是否使用预存款进行支付
        payment_code: 'alipay_h5' // 支付方式

      },
      payment_list: [],
      showNotice: 0,
      notice: this.$route.query.notice,
      ifLoaded: false
    }
  },
  computed: {
    ...mapState({
      token: state => state.member.token

    })
  },
  created: function () {
    let _this = this
    loadScript('uniapp', 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js', function () {
      uni.getEnv(function (res) {
        _this.ifLoaded = true
        if (res.plus) {
          _this.uniapp = 1
        }
      })
    })

    this.getMemberPayInfo()
  },
  watch: {
    showNotice: function (val) {
      if (val && this.notice) {
        MessageBox.confirm('如果您已完成支付，请点击“完成付款”按钮，如果您未完成支付，请点击“重新支付”重新发起支付', '确认支付是否完成', { cancelButtonText: '重新支付', confirmButtonText: '完成付款' }).then(action => {
          this.goNext()
        })
      }
    },
    ifLoaded: function (val) {
      if (val) {
        this.getPaymentList()
      }
    }
  },
  methods: {
    goBack () {
      if (this.notice) {
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    },
    setClass(code){
        let obj = {}
        obj["icon " + code] = true
        return obj
    },
    goNext () {
      if (this.pay_type === 'pay_new') {
        this.$router.push({ name: 'MemberOrderList' })
      } else if (this.pay_type === 'vr_pay_new') {
        this.$router.push({ name: 'MemberVrOrderList' })
      } else if (this.pay_type === 'pd_pay') {
        this.$router.push({ name: 'MemberRechargeList' })
      }
    },
    payType (code) {
      this.payment_info.payment_code = code
    },
    getPaymentList () {
      let _this = this

      getPaymentList(this.uniapp).then(res => {
        this.payment_list = res.result.payment_list
        if (this.payment_list.length) {
				  this.payment_info.payment_code = this.payment_list[0].payment_code
        }
        loadScript('weixin', 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js', function () {
          wx.miniProgram.getEnv(function (res) {
            for (var i in _this.payment_list) {
              if (res.miniprogram) {
                if (_this.payment_list[i].payment_code == 'wxpay_jsapi') {
                  _this.payment_list.splice(i, 1)
                  break
                }
              } else {
                if (_this.payment_list[i].payment_code == 'wxpay_minipro') {
                  _this.payment_list.splice(i, 1)
                  break
                }
              }
            }
          })
        })
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    getMemberPayInfo () {
      if (this.pay_type === 'pay_new') {
        let _this = this
        getOrderpayInfo(
          this.pay_sn
        ).then((res) => {
          if (res.code === 10000) {
            this.pay_info = res.result.pay_info
          }
          this.showNotice = 1
        }).catch(function (error) {
          if (error.code === 12001) { // 订单已经支付
            _this.goNext()
          } else {
            Toast(error.message)
          }
        })
      } else if (this.pay_type === 'vr_pay_new') {
        let _this = this
        getVrOrderpayInfo(
          this.pay_sn
        ).then((res) => {
          if (res.code === 10000) {
            this.pay_info = res.result.pay_info
          }
          this.showNotice = 1
        }).catch(function (error) {
          if (error.code === 12001) { // 订单已经支付
            _this.goNext()
          } else {
            Toast(error.message)
          }
        })
      } else if (this.pay_type === 'pd_pay') {
        getRechargeInfo(
          this.pay_sn
        ).then((res) => {
          if (res.code === 10000) {
            this.pay_info = { pay_amount: res.result.pdinfo.pdr_amount }
          }
          this.showNotice = 1
        }).catch(function (error) {
          if (error.code === 12001) { // 订单已经支付
            _this.goNext()
          } else {
            Toast(error.message)
          }
        })
      }
    },
    submit () {
      if (this.payment_info.pd_pay || this.payment_info.rcb_pay) {
        if (!this.pay_info.member_paypwd) {
          MessageBox.confirm('您需要先去设置支付密码', '').then(action => {
            this.$router.push({ name: 'MemberSetting' })
          })
        } else {
          if (!this.payment_info.password) {
            MessageBox.prompt('<b>请输入支付密码</b><br/>注：默认支付密码为：123456', '', {
              showCancelButton: true,
              inputType: 'password'

            }).then(({ value, action }) => {
              this.payment_info.password = value
              this.submit()
            })
            return
          }
        }
      }
      var param = 'action=' + this.pay_type + '&key=' + this.token + '&pay_sn=' + this.pay_sn + '&password=' + this.payment_info.password + '&rcb_pay=' + this.payment_info.rcb_pay + '&pd_pay=' + this.payment_info.pd_pay + '&payment_code=' + this.payment_info.payment_code
      if (this.payment_info.payment_code == 'wxpay_minipro') {
        wx.miniProgram.redirectTo({ url: '../pay/pay?' + param })
        return
      }
      if (this.uniapp) {
        uni.redirectTo({ url: 'pay?' + param })
        return
      }
      pay(
        this.pay_sn, this.pay_type, this.payment_info, this.token, this.uniapp
      ).then((res) => {
        if (res.code) {
          if (res.code === 10000 || res.code === 12001) {
            this.goNext()
          } else {
            Toast(res.message)
          }
        } else {
          document.write(res)
        }
      }).catch(function (error) {
        if (error.message) {
          Toast(error.message)
        } else {
          document.write(error)
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
    .container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: $mainbgColor;
    }
    .top-wrapper {
        height: 6rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
        margin-bottom: 0.75rem;
    }
    .row-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .title-wrapper {
        height: 3.2rem;
    }
    .subtitle-wrapper {
        height: 1.5rem;
        margin-top: 0.5rem;
    }
    .icon {
        width: 0.9rem;
        height: 0.9rem;
        margin-left: 0.8rem;
        margin-right: 0.5rem;
    }
    .title {
        font-size: 0.8rem;
        color: #3C3C3C;
    }
    .subtitle {
        font-size: 0.8rem;
        color: #4D4D4D;
        margin-left: 2.5rem;
    }
    .price {
        font-size: 0.8rem;
        color: $primaryColor;
    }
    .item-wrapper{
        height: 3.1rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background-color: #fff;
        border-bottom: 1px solid $lineColor;
    }
    .item-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
    }
    .item-left-wrapper {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        i{background-image: url(../../../assets/image/wxpayicon.png);background-repeat: no-repeat;background-size: 100%;}
        .alipay_h5,.alipay_app{background-image: url(../../../assets/image/alipayicon.jpg);background-repeat: no-repeat;background-size: 100%; }
        .paypal_h5,.paypal_app{background-image: url(../../../assets/image/paypalicon.jpg);background-repeat: no-repeat;background-size: 100%; }
    }
    .item-right-wrapper {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }
    .item-title {
        font-size: 0.8rem;
        color: #3C3C3C;
    }
    .item-subtitle {
        font-size: 0.8rem;
        color: #8C8C8C;
        margin-right:0.25rem;
        text-align: right;
    }
    .item-select {
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 1.1rem;
    }
    .indicator {
        width: 0.7rem;
        height: 0.7rem;
        margin-left:0.25rem;
        margin-right: 0.8rem;
    }
    .action-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 2.5rem;
        margin-top: 2.25rem;
    }
</style>
